import { TYPE_SET_PAGINATION } from "app/redux/chats&notifications/chatsTypes";

export const actionSetPagination = {
  type: TYPE_SET_PAGINATION,
}
